<template>
  <div v-if="gaps.length" class="prod-gaps">
    <p class="prod-gaps__label">
      {{ gaps.length }} {{ gaps.length === 1 ? 'item' : 'items' }} missing
    </p>
    <ul class="prod-gaps__list">
      <li v-for="gap in gaps" :key="gap.key">
        <router-link
          v-if="linkFor(gap)"
          :to="linkFor(gap)"
          class="prod-gap-chip"
          :class="`prod-gap-chip--${gap.state}`"
          @click.stop
        >
          {{ gap.label }}
          <span class="prod-gap-chip__state">{{ gap.state }}</span>
        </router-link>
        <span
          v-else
          class="prod-gap-chip"
          :class="`prod-gap-chip--${gap.state}`"
        >
          {{ gap.label }}
          <span class="prod-gap-chip__state">{{ gap.state }}</span>
        </span>
      </li>
    </ul>
  </div>
  <p v-else-if="showReady" class="prod-gaps prod-gaps--ready">
    <span class="material-icons">check_circle</span>
    All set
  </p>
</template>

<script setup>
/* global defineProps */
import { computed } from 'vue'

const props = defineProps({
  gaps: {
    type: Array,
    default: () => []
  },
  productionId: {
    type: [String, Number],
    default: null
  },
  linked: {
    type: Boolean,
    default: false
  },
  showReady: {
    type: Boolean,
    default: false
  }
})

const gaps = computed(() => props.gaps || [])

function linkFor (gap) {
  if (!props.linked || !props.productionId || !gap?.to) return ''
  return `/production/productions/${props.productionId}/${gap.to}`
}
</script>
